"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isComplexUnit = isComplexUnit;
exports.splitComplexUnitIntoSimpleUnits = splitComplexUnitIntoSimpleUnits;
exports.isUnitString = isUnitString;
exports.getUnitForStorage = getUnitForStorage;
exports.getRelatedUnits = getRelatedUnits;
exports.unitsAreRelated = unitsAreRelated;
exports.getUnitConversionMultiplier = getUnitConversionMultiplier;
exports.findByValue = findByValue;
exports.getUnitLabel = getUnitLabel;
exports.unitsAreEqual = unitsAreEqual;
exports.convertUnits = convertUnits;
exports.convertToPreferredUnitsForAnalytics = convertToPreferredUnitsForAnalytics;
exports.convertUnitForAnalytics = convertUnitForAnalytics;
exports.UNIT_TYPES_LIST = exports.COMPLEX_UNIT_TYPES_LIST = exports.NON_GENERATED_COMPLEX_UNIT_TYPES = exports.SIMPLE_UNIT_TYPES = exports.MEASUREMENT_STORAGE_UNITS = exports.Measurements = exports.SimpleUnits = void 0;

var _MEASUREMENT_STORAGE_;

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// Those units strings represent exact value that we store in the DB.
// They mustn't be changed without DB migration.
var SimpleUnits;
exports.SimpleUnits = SimpleUnits;

(function (SimpleUnits) {
  SimpleUnits["ACRE"] = "acre";
  SimpleUnits["ACRE_FEET"] = "acreFeet";
  SimpleUnits["AMPERE"] = "amps";
  SimpleUnits["ATM"] = "standardAtmosphere";
  SimpleUnits["BAR"] = "Bar";
  SimpleUnits["BARREL"] = "barrel";
  SimpleUnits["BF"] = "bf";
  SimpleUnits["BONE_DRY_TONS"] = "bdt";
  SimpleUnits["BONE_DRY_UNITS"] = "bdu";
  SimpleUnits["BOOLEAN"] = "boolean";
  SimpleUnits["BTU"] = "btu";
  SimpleUnits["BUCKET_32_LBS"] = "bucket32lbs";
  SimpleUnits["BUCKET_5_GALS"] = "bucket5gals";
  SimpleUnits["CCF"] = "ccf";
  SimpleUnits["CELSIUS"] = "celsius";
  SimpleUnits["CENTIMETERS"] = "centimeters";
  SimpleUnits["CFU"] = "cfu";
  SimpleUnits["CFU_PER_100ML"] = "cfuPer100ml";
  SimpleUnits["CFU_PER_GRAM"] = "cfuPerGram";
  SimpleUnits["CNT"] = "cnt";
  SimpleUnits["CNT_PER_100ML"] = "cntPer100ml";
  SimpleUnits["CNT_PER_GRAM"] = "cntPerGram";
  SimpleUnits["COLIFORMS_PER_100ML"] = "coliformsPer100ml";
  SimpleUnits["COLONIES"] = "colonies";
  SimpleUnits["COLONIES_PER_GRAM"] = "coloniesPerGram";
  SimpleUnits["CUBIC_CENTIMETERS"] = "cubicCentimeters";
  SimpleUnits["CUBIC_FEET"] = "cubicFeet";
  SimpleUnits["CUBIC_METER"] = "cubicMeter";
  SimpleUnits["CUBIC_YARDS"] = "cubicYards";
  SimpleUnits["C_CF"] = "hundredCubicFeet";
  SimpleUnits["DAYS"] = "days";
  SimpleUnits["DECIBELS"] = "decibel";
  SimpleUnits["DOLLARS"] = "dollars";
  SimpleUnits["DRUM"] = "drum";
  SimpleUnits["EUROS"] = "euros";
  SimpleUnits["FAHRENHEIT"] = "fahrenheit";
  SimpleUnits["FEET"] = "feet";
  SimpleUnits["FEET_EXP_TWO_FIVE"] = "feetExpTwoPointFive";
  SimpleUnits["FEET_EXP_ZERO_FIVE"] = "feetExpZeroFive";
  SimpleUnits["GALLONS"] = "gallons";
  SimpleUnits["GIGAHERTZ"] = "gigahertz";
  SimpleUnits["GRAMS"] = "grams";
  SimpleUnits["GRAM_MOLES"] = "gramMol";
  SimpleUnits["GRAINS"] = "grains";
  SimpleUnits["GIGAJOULE"] = "gigajoule";
  SimpleUnits["HERTZ"] = "hertz";
  SimpleUnits["HORSEPOWER"] = "horsepower";
  SimpleUnits["HORSEPOWER_HOURS"] = "horsepowerHours";
  SimpleUnits["HOURS"] = "hours";
  SimpleUnits["INCHES"] = "inches";
  SimpleUnits["INCHES_SQUARE"] = "inchesSquare";
  SimpleUnits["IN_HG"] = "inchesMercury";
  SimpleUnits["IN_OF_WATER_COLUMN"] = "inchesOfWaterColumn";
  SimpleUnits["JOULE"] = "joule";
  SimpleUnits["KILOHERTZ"] = "kilohertz";
  SimpleUnits["KILOGRAMS"] = "kg";
  SimpleUnits["KILOJOULE"] = "kilojoule";
  SimpleUnits["KILOMETERS"] = "km";
  SimpleUnits["KILOVOLTS"] = "kilovolts";
  SimpleUnits["KILOWATTS"] = "kilowatts";
  SimpleUnits["KWH"] = "kWh";
  SimpleUnits["LBS_PER_MSF"] = "lbsPerMsf";
  SimpleUnits["LINEAR_FEET"] = "linearFeet";
  SimpleUnits["LITERS"] = "liters";
  SimpleUnits["MASS_CONCENTRATION"] = "massConcentration";
  SimpleUnits["MBF"] = "mbf";
  SimpleUnits["MCF"] = "mcf";
  SimpleUnits["MEGAHERTZ"] = "megahertz";
  SimpleUnits["MEGAJOULE"] = "megajoule";
  SimpleUnits["MEGAWATT_HOURS"] = "megawattHours";
  SimpleUnits["METERS"] = "meters";
  SimpleUnits["METERS_SQUARED"] = "metersSquared";
  SimpleUnits["METRIC_TONS"] = "metricTons";
  SimpleUnits["MGAL"] = "mgal";
  SimpleUnits["MG"] = "milligrams";
  SimpleUnits["MICROMHOS"] = "micromhos";
  SimpleUnits["MICROSIEMENS"] = "microsiemens";
  SimpleUnits["MILES"] = "miles";
  SimpleUnits["MILLIAMPS"] = "milliamps";
  SimpleUnits["MILLIBAR"] = "millibar";
  SimpleUnits["MOLES"] = "mol";
  SimpleUnits["ML_PER_LITER_PER_HOUR"] = "millilitersPerLiterPerHour";
  SimpleUnits["MILLIMHOS"] = "millimhos";
  SimpleUnits["MILLION_FIBERS_PER_LITER"] = "millionFibersPerLiter";
  SimpleUnits["MINUTES"] = "minutes";
  SimpleUnits["ML"] = "milliliters";
  SimpleUnits["MMHG"] = "millimeterMercury";
  SimpleUnits["MMBTU"] = "millionBtu";
  SimpleUnits["MMCF"] = "mmcf";
  SimpleUnits["MM_CF"] = "millionCubicFeet";
  SimpleUnits["MPN"] = "mpn";
  SimpleUnits["MPN_PER_100_ML"] = "mpnPer100mL";
  SimpleUnits["MPN_PER_GRAM"] = "mpnPerGram";
  SimpleUnits["M_CF"] = "thousandCubicFeet";
  SimpleUnits["MSF"] = "msf";
  SimpleUnits["M_SQUARE_FEET"] = "thousandSquareFeet";
  SimpleUnits["NG"] = "nanograms";
  SimpleUnits["NORMAL_CUBIC_METERS"] = "normalCubicMeters";
  SimpleUnits["NTU"] = "ntu";
  SimpleUnits["OVEN_DRY_TONS"] = "odt";
  SimpleUnits["OUNCES"] = "ounces";
  SimpleUnits["OUNCES_DRY"] = "ouncesDry";
  SimpleUnits["PASCALS"] = "Pascals";
  SimpleUnits["PERCENT"] = "%";
  SimpleUnits["PERCENT_GRAMS_PER_LITER"] = "percentGramsPerLiter";
  SimpleUnits["PERCENT_SURVIVAL"] = "percentSurvival";
  SimpleUnits["PERCENT_VOLUME_PER_VOLUME"] = "percentVolumePerVolume";
  SimpleUnits["PERCENT_WEIGHT"] = "percentWeight";
  SimpleUnits["PERCENT_WEIGHT_PER_VOLUME"] = "percentWeightPerVolume";
  SimpleUnits["PICOCURIES"] = "picocuries";
  SimpleUnits["PICOGRAMS"] = "picograms";
  SimpleUnits["PINTS"] = "pints";
  SimpleUnits["POUNDS"] = "lbs";
  SimpleUnits["POUND_MOLES"] = "lbMol";
  SimpleUnits["PPB"] = "ppb";
  SimpleUnits["PPM"] = "ppm";
  SimpleUnits["PPM_VOLUME"] = "ppmVolume";
  SimpleUnits["PPM_WEIGHT"] = "ppmWeight";
  SimpleUnits["PPT"] = "ppt";
  SimpleUnits["QUARTS"] = "quarts";
  SimpleUnits["SCF"] = "scf";
  SimpleUnits["SECONDS"] = "seconds";
  SimpleUnits["SECONDS_SQUARED"] = "secondsSquared";
  SimpleUnits["SF"] = "sf";
  SimpleUnits["SQUARE_FEET"] = "squareFeet";
  SimpleUnits["SU"] = "standardUnits";
  SimpleUnits["TERAHERTZ"] = "terahertz";
  SimpleUnits["THERMS"] = "therms";
  SimpleUnits["THOUSAND_GALLONS"] = "thousandGallons";
  SimpleUnits["TONS"] = "tons";
  SimpleUnits["TORR"] = "Torr";
  SimpleUnits["TOXIC_UNIT_ACUTE"] = "toxicUnitAcute";
  SimpleUnits["UG"] = "micrograms";
  SimpleUnits["UNITLESS"] = "unitless";
  SimpleUnits["VMT"] = "vmt";
  SimpleUnits["VOLTS"] = "volts";
  SimpleUnits["VOLUME_CONCENTRATION"] = "volumeConcentration";
  SimpleUnits["WATTS"] = "watts";
  SimpleUnits["WATT_HOURS"] = "Wh";
  SimpleUnits["WEIGHT_CONCENTRATION"] = "weightConcentration";
  SimpleUnits["YARDS"] = "yards";
  SimpleUnits["YEARS"] = "years";
})(SimpleUnits || (exports.SimpleUnits = SimpleUnits = {}));

function isComplexUnit(unitValue) {
  // Matches eg mg/l or lbs/gallon
  return /\//.test(unitValue);
}

function splitComplexUnitIntoSimpleUnits(unitValue) {
  return unitValue.split('/');
} // All the measurement types that Mapistry supports.
// Units of one group can be converted one into another,
// units of one group are stored in the same storage unit in the DB.


var Measurements; // When a log record is saved, its value will be converted and stored in those units.
// Calculations and year/quarter/month total will be calculated in storage units
// and then be converted to the target units before passing data to the FE.
// Those storage units mustn't be changed without DB migration!

exports.Measurements = Measurements;

(function (Measurements) {
  Measurements["AREA"] = "area";
  Measurements["BACTERIA_COUNT"] = "bacteriaCount";
  Measurements["BOOLEAN"] = "boolean";
  Measurements["CONCENTRATION"] = "concentration";
  Measurements["CURRENCY"] = "currency";
  Measurements["ELECTRIC_CONDUCTANCE"] = "electricConductance";
  Measurements["FLOW_RATE"] = "flowRate";
  Measurements["FREQUENCY"] = "frequency";
  Measurements["LENGTH"] = "length";
  Measurements["MASS"] = "mass";
  Measurements["MASS_LOAD"] = "massLoad";
  Measurements["PH"] = "ph";
  Measurements["POWER"] = "power";
  Measurements["PRESSURE"] = "pressure";
  Measurements["RADON_LEVEL"] = "radonLevel";
  Measurements["SOIL_ELECTRICAL_CONDUCTIVITY"] = "soilElectricalConductivity";
  Measurements["TEMPERATURE"] = "temperature";
  Measurements["THERMAL"] = "thermal";
  Measurements["TIME"] = "time";
  Measurements["TOXICITY"] = "toxicity";
  Measurements["TURBIDITY"] = "turbidity";
  Measurements["UNITLESS"] = "unitless";
  Measurements["VELOCITY"] = "velocity";
  Measurements["VOLUME"] = "volume";
})(Measurements || (exports.Measurements = Measurements = {}));

var MEASUREMENT_STORAGE_UNITS = (_MEASUREMENT_STORAGE_ = {}, _defineProperty(_MEASUREMENT_STORAGE_, Measurements.AREA, SimpleUnits.SQUARE_FEET), _defineProperty(_MEASUREMENT_STORAGE_, Measurements.BACTERIA_COUNT, SimpleUnits.COLIFORMS_PER_100ML), _defineProperty(_MEASUREMENT_STORAGE_, Measurements.BOOLEAN, SimpleUnits.BOOLEAN), _defineProperty(_MEASUREMENT_STORAGE_, Measurements.CONCENTRATION, "".concat(SimpleUnits.POUNDS, "/").concat(SimpleUnits.CUBIC_FEET)), _defineProperty(_MEASUREMENT_STORAGE_, Measurements.CURRENCY, SimpleUnits.DOLLARS), _defineProperty(_MEASUREMENT_STORAGE_, Measurements.ELECTRIC_CONDUCTANCE, SimpleUnits.MICROMHOS), _defineProperty(_MEASUREMENT_STORAGE_, Measurements.FREQUENCY, SimpleUnits.HERTZ), _defineProperty(_MEASUREMENT_STORAGE_, Measurements.FLOW_RATE, "".concat(SimpleUnits.CUBIC_FEET, "/").concat(SimpleUnits.SECONDS)), _defineProperty(_MEASUREMENT_STORAGE_, Measurements.LENGTH, SimpleUnits.FEET), _defineProperty(_MEASUREMENT_STORAGE_, Measurements.MASS, SimpleUnits.POUNDS), _defineProperty(_MEASUREMENT_STORAGE_, Measurements.MASS_LOAD, "".concat(SimpleUnits.POUNDS, "/").concat(SimpleUnits.SECONDS)), _defineProperty(_MEASUREMENT_STORAGE_, Measurements.PH, SimpleUnits.SU), _defineProperty(_MEASUREMENT_STORAGE_, Measurements.POWER, SimpleUnits.WATTS), _defineProperty(_MEASUREMENT_STORAGE_, Measurements.PRESSURE, SimpleUnits.MMHG), _defineProperty(_MEASUREMENT_STORAGE_, Measurements.RADON_LEVEL, "".concat(SimpleUnits.PICOCURIES, "/").concat(SimpleUnits.LITERS)), _defineProperty(_MEASUREMENT_STORAGE_, Measurements.SOIL_ELECTRICAL_CONDUCTIVITY, "".concat(SimpleUnits.MICROMHOS, "/").concat(SimpleUnits.FEET)), _defineProperty(_MEASUREMENT_STORAGE_, Measurements.TEMPERATURE, SimpleUnits.FAHRENHEIT), _defineProperty(_MEASUREMENT_STORAGE_, Measurements.THERMAL, SimpleUnits.BTU), _defineProperty(_MEASUREMENT_STORAGE_, Measurements.TIME, SimpleUnits.SECONDS), _defineProperty(_MEASUREMENT_STORAGE_, Measurements.TOXICITY, SimpleUnits.TOXIC_UNIT_ACUTE), _defineProperty(_MEASUREMENT_STORAGE_, Measurements.TURBIDITY, SimpleUnits.NTU), _defineProperty(_MEASUREMENT_STORAGE_, Measurements.UNITLESS, SimpleUnits.UNITLESS), _defineProperty(_MEASUREMENT_STORAGE_, Measurements.VELOCITY, "".concat(SimpleUnits.FEET, "/").concat(SimpleUnits.SECONDS)), _defineProperty(_MEASUREMENT_STORAGE_, Measurements.VOLUME, SimpleUnits.CUBIC_FEET), _MEASUREMENT_STORAGE_);
exports.MEASUREMENT_STORAGE_UNITS = MEASUREMENT_STORAGE_UNITS;
var SIMPLE_UNIT_TYPES = {
  ACRE: {
    label: 'acres',
    singularLabel: 'acre',
    value: SimpleUnits.ACRE,
    mathValue: 'acre',
    measure: Measurements.AREA,
    toStorageUnit: 43560
  },
  ACRE_FEET: {
    label: 'acre-ft',
    value: SimpleUnits.ACRE_FEET,
    mathValue: 'acre ft',
    measure: Measurements.VOLUME,
    toStorageUnit: 43559.93510762
  },
  AMPERE: {
    label: 'A',
    longLabel: 'amps',
    value: SimpleUnits.AMPERE,
    mathValue: 'ampere'
  },
  ATM: {
    label: 'atm',
    value: SimpleUnits.ATM,
    mathValue: 'atm',
    measure: Measurements.PRESSURE,
    toStorageUnit: 760
  },
  BAR: {
    label: 'bar',
    value: SimpleUnits.BAR,
    mathValue: 'bar',
    measure: Measurements.PRESSURE,
    toStorageUnit: 750.061575845656
  },
  BARREL: {
    label: 'barrel',
    value: SimpleUnits.BARREL,
    mathValue: 'barrel',
    measure: Measurements.VOLUME,
    toStorageUnit: 5.61458333
  },
  BOOLEAN: {
    label: 'boolean',
    value: SimpleUnits.BOOLEAN,
    measure: Measurements.BOOLEAN,
    toStorageUnit: 1
  },
  BF: {
    label: 'board feet',
    singularLabel: 'board foot',
    mathValue: 'BF',
    measure: Measurements.VOLUME,
    toStorageUnit: 1 / 12,
    // 144 in^3 to ft^3
    value: SimpleUnits.BF
  },
  BONE_DRY_TONS: {
    label: 'bone dry tons',
    mathValue: 'bone_dry_tons',
    measure: Measurements.MASS,
    toStorageUnit: 2000,
    value: SimpleUnits.BONE_DRY_TONS
  },
  BONE_DRY_UNITS: {
    label: 'bone dry units',
    mathValue: 'bone_dry_units',
    measure: Measurements.MASS,
    toStorageUnit: 2400,
    value: SimpleUnits.BONE_DRY_UNITS
  },
  BTU: {
    label: 'BTU',
    value: SimpleUnits.BTU,
    mathValue: 'BTU',
    measure: Measurements.THERMAL,
    toStorageUnit: 1
  },
  BUCKET_32_LBS: {
    label: '32-lbs buckets',
    singularLabel: '32-lbs bucket',
    value: SimpleUnits.BUCKET_32_LBS,
    mathValue: 'bucket32lbs',
    measure: Measurements.MASS,
    toStorageUnit: 32
  },
  BUCKET_5_GALS: {
    label: '5-gal buckets',
    singularLabel: '5-gal bucket',
    value: SimpleUnits.BUCKET_5_GALS,
    mathValue: 'bucket5gals',
    measure: Measurements.VOLUME,
    toStorageUnit: 0.6684027777777
  },
  CCF: {
    label: 'CCF',
    mathValue: 'CCF',
    value: SimpleUnits.CCF
  },
  CELSIUS: {
    label: '°C',
    value: SimpleUnits.CELSIUS,
    mathValue: 'degC',
    measure: Measurements.TEMPERATURE,
    fromStorageUnitFunc: function fromStorageUnitFunc(value) {
      return (value - 32) * 5 / 9;
    },
    toStorageUnitFunc: function toStorageUnitFunc(value) {
      return value * 9 / 5 + 32;
    }
  },
  CENTIMETERS: {
    label: 'cm',
    value: SimpleUnits.CENTIMETERS,
    mathValue: 'cm',
    measure: Measurements.LENGTH,
    toStorageUnit: 0.0328083989501
  },
  CFU: {
    label: 'CFU',
    // new unit for Data 2.0 therefore no conversion in Logs 1.0
    longLabel: 'Colony Forming Units',
    value: SimpleUnits.CFU,
    mathValue: 'CFU'
  },
  CFU_PER_100ML: {
    label: 'cfu/100mL',
    value: SimpleUnits.CFU_PER_100ML,
    mathValue: 'CFU_per_100ml',
    measure: Measurements.BACTERIA_COUNT,
    toStorageUnit: 1,
    suite: 'water'
  },
  CFU_PER_GRAM: {
    label: 'CFU/g',
    // new unit for Data 2.0 therefore no conversion in Logs 1.0
    value: SimpleUnits.CFU_PER_GRAM,
    mathValue: 'CFU_per_gram'
  },
  CNT: {
    label: 'CNT',
    // new unit for Data 2.0 therefore no conversion in Logs 1.0
    longLabel: 'Bacteria count',
    value: SimpleUnits.CNT,
    mathValue: 'CNT'
  },
  CNT_PER_100ML: {
    label: 'cnt/100mL',
    value: SimpleUnits.CNT_PER_100ML,
    mathValue: 'CNT_per_100ml',
    measure: Measurements.BACTERIA_COUNT,
    toStorageUnit: 1,
    suite: 'water'
  },
  CNT_PER_GRAM: {
    label: 'CNT/g',
    // new unit for Data 2.0 therefore no conversion in Logs 1.0
    value: SimpleUnits.CNT_PER_GRAM,
    mathValue: 'CNT_per_gram'
  },
  COLIFORMS_PER_100ML: {
    label: 'col/100mL',
    value: SimpleUnits.COLIFORMS_PER_100ML,
    mathValue: 'col_per_100ml',
    measure: Measurements.BACTERIA_COUNT,
    toStorageUnit: 1,
    suite: 'water'
  },
  COLONIES: {
    label: 'Colonies',
    // new unit for Data 2.0 therefore no conversion in Logs 1.0
    value: SimpleUnits.COLONIES,
    mathValue: 'colonies'
  },
  COLONIES_PER_GRAM: {
    label: 'col/g',
    // new unit for Data 2.0 therefore no conversion in Logs 1.0
    value: SimpleUnits.COLONIES_PER_GRAM,
    mathValue: 'col_per_gram'
  },
  CUBIC_CENTIMETERS: {
    label: 'cm³',
    value: SimpleUnits.CUBIC_CENTIMETERS,
    mathValue: 'cm^3',
    measure: Measurements.VOLUME,
    // eslint-disable-next-line @typescript-eslint/no-loss-of-precision
    toStorageUnit: 0.000035314666721488588
  },
  CUBIC_FEET: {
    label: 'ft³',
    value: SimpleUnits.CUBIC_FEET,
    mathValue: 'ft^3',
    measure: Measurements.VOLUME,
    toStorageUnit: 1,
    exponentBase: SimpleUnits.FEET,
    raisedTo: 3
  },
  CUBIC_METER: {
    label: 'm³',
    value: SimpleUnits.CUBIC_METER,
    mathValue: 'm^3',
    measure: Measurements.VOLUME,
    // eslint-disable-next-line @typescript-eslint/no-loss-of-precision
    toStorageUnit: 35.314666721488588
  },
  CUBIC_YARDS: {
    label: 'yards³',
    value: SimpleUnits.CUBIC_YARDS,
    mathValue: 'yd^3',
    measure: Measurements.VOLUME,
    toStorageUnit: 27
  },
  C_CF: {
    label: 'hundred ft³',
    mathValue: 'hundred_ft3',
    measure: Measurements.VOLUME,
    value: SimpleUnits.C_CF,
    toStorageUnit: 100
  },
  DAYS: {
    label: 'days',
    singularLabel: 'day',
    value: SimpleUnits.DAYS,
    mathValue: 'day',
    measure: Measurements.TIME,
    toStorageUnit: 86400
  },
  DECIBELS: {
    label: 'decibels',
    mathValue: 'decibel',
    value: SimpleUnits.DECIBELS
  },
  DOLLARS: {
    label: '$',
    value: SimpleUnits.DOLLARS,
    mathValue: 'USD',
    measure: Measurements.CURRENCY,
    toStorageUnit: 1
  },
  DRUM: {
    label: '55-gal drums',
    singularLabel: '55-gal drum',
    value: SimpleUnits.DRUM,
    mathValue: 'drum55gal',
    measure: Measurements.VOLUME,
    toStorageUnit: 7.3524305555556
  },
  EUROS: {
    label: '€',
    value: SimpleUnits.EUROS,
    mathValue: 'EURO',
    measure: Measurements.CURRENCY,
    toStorageUnit: 1.19 // Conversion as of 2021-03-22 19:05 UTC. TODO: Make this dynamic in the future?

  },
  FAHRENHEIT: {
    label: '°F',
    value: SimpleUnits.FAHRENHEIT,
    mathValue: 'degF',
    measure: Measurements.TEMPERATURE,
    fromStorageUnitFunc: function fromStorageUnitFunc(value) {
      return value;
    },
    toStorageUnitFunc: function toStorageUnitFunc(value) {
      return value;
    }
  },
  FEET: {
    label: 'ft',
    value: SimpleUnits.FEET,
    mathValue: 'ft',
    measure: Measurements.LENGTH,
    toStorageUnit: 1
  },
  FEET_EXP_TWO_FIVE: {
    label: 'ft^2.5',
    value: SimpleUnits.FEET_EXP_TWO_FIVE,
    mathValue: 'ft^2.5',
    exponentBase: SimpleUnits.FEET,
    raisedTo: 2.5
  },
  FEET_EXP_ZERO_FIVE: {
    label: '√ft',
    value: SimpleUnits.FEET_EXP_ZERO_FIVE,
    mathValue: 'ft^0.5',
    exponentBase: SimpleUnits.FEET,
    raisedTo: 0.5
  },
  GALLONS: {
    label: 'gallons',
    singularLabel: 'gallon',
    value: SimpleUnits.GALLONS,
    mathValue: 'gal',
    measure: Measurements.VOLUME,
    // eslint-disable-next-line @typescript-eslint/no-loss-of-precision
    toStorageUnit: 0.133680555555555547
  },
  GIGAHERTZ: {
    label: 'GHz',
    value: SimpleUnits.GIGAHERTZ,
    mathValue: 'GHz',
    measure: Measurements.FREQUENCY,
    toStorageUnit: 1000000000
  },
  GIGAJOULE: {
    label: 'GJ',
    value: SimpleUnits.GIGAJOULE,
    mathValue: 'GJ',
    measure: Measurements.THERMAL,
    toStorageUnit: 1000000000 / 1055.05585262 // BTU (IT)

  },
  GRAMS: {
    label: 'g',
    longLabel: 'grams',
    value: SimpleUnits.GRAMS,
    mathValue: 'g',
    measure: Measurements.MASS,
    toStorageUnit: 1 / 453.59237
  },
  GRAM_MOLES: {
    label: 'g-mol',
    value: SimpleUnits.GRAM_MOLES,
    mathValue: 'g_mol'
  },
  GRAINS: {
    label: 'gr',
    longLabel: 'grains',
    value: SimpleUnits.GRAINS,
    mathValue: 'gr',
    measure: Measurements.MASS,
    toStorageUnit: 1 / 7000
  },
  HERTZ: {
    label: 'Hz',
    value: SimpleUnits.HERTZ,
    mathValue: 'Hz',
    measure: Measurements.FREQUENCY,
    toStorageUnit: 1
  },
  HORSEPOWER: {
    label: 'horsepower',
    value: SimpleUnits.HORSEPOWER,
    mathValue: 'hp',
    measure: Measurements.POWER,
    toStorageUnit: 745.7
  },
  HORSEPOWER_HOURS: {
    label: 'hp·hr',
    value: SimpleUnits.HORSEPOWER_HOURS,
    mathValue: 'hp*hr',
    measure: Measurements.THERMAL,
    toStorageUnit: 745.7 * 3600 / 1055.05585262 // BTU (IT)

  },
  HOURS: {
    label: 'hr',
    longLabel: 'hours',
    value: SimpleUnits.HOURS,
    mathValue: 'hr',
    measure: Measurements.TIME,
    toStorageUnit: 3600
  },
  INCHES: {
    label: 'in',
    longLabel: 'inches',
    value: SimpleUnits.INCHES,
    mathValue: 'in',
    measure: Measurements.LENGTH,
    toStorageUnit: 0.08333333333
  },
  INCHES_SQUARE: {
    label: 'in²',
    value: SimpleUnits.INCHES_SQUARE,
    mathValue: 'in^2',
    measure: Measurements.AREA,
    toStorageUnit: 0.006944444444,
    exponentBase: SimpleUnits.INCHES,
    raisedTo: 2
  },
  IN_HG: {
    label: 'inHg',
    value: SimpleUnits.IN_HG,
    mathValue: 'inHg',
    measure: Measurements.PRESSURE,
    toStorageUnit: 25.4
  },
  IN_OF_WATER_COLUMN: {
    label: 'inH2O',
    longLabel: 'in of water column',
    value: SimpleUnits.IN_OF_WATER_COLUMN,
    mathValue: 'inH2O',
    measure: Measurements.PRESSURE,
    // eslint-disable-next-line @typescript-eslint/no-loss-of-precision
    toStorageUnit: 1.8664532253343312
  },
  JOULE: {
    label: 'J',
    longLabel: 'joules',
    value: SimpleUnits.JOULE,
    mathValue: 'J',
    measure: Measurements.THERMAL,
    toStorageUnit: 1 / 1055.05585262 // BTU (IT)

  },
  THOUSAND_GALLONS: {
    label: 'thousand gallons',
    value: SimpleUnits.THOUSAND_GALLONS,
    mathValue: 'thousand_gallons',
    measure: Measurements.VOLUME,
    // eslint-disable-next-line @typescript-eslint/no-loss-of-precision
    toStorageUnit: 133.680555555555547
  },
  KILOGRAMS: {
    label: 'kg',
    value: SimpleUnits.KILOGRAMS,
    mathValue: 'kg',
    measure: Measurements.MASS,
    toStorageUnit: 1 / 0.45359237
  },
  KILOHERTZ: {
    label: 'kHz',
    value: SimpleUnits.KILOHERTZ,
    mathValue: 'kHz',
    measure: Measurements.FREQUENCY,
    toStorageUnit: 1000
  },
  KILOJOULE: {
    label: 'kJ',
    value: SimpleUnits.KILOJOULE,
    mathValue: 'kJ',
    measure: Measurements.THERMAL,
    toStorageUnit: 1000 / 1055.05585262 // BTU (IT)

  },
  KILOMETERS: {
    label: 'km',
    value: SimpleUnits.KILOMETERS,
    mathValue: 'km',
    measure: Measurements.LENGTH,
    toStorageUnit: 3280.83989501
  },
  KILOVOLTS: {
    label: 'kV',
    longLabel: 'kilovolts',
    value: SimpleUnits.KILOVOLTS,
    mathValue: 'kV'
  },
  KILOWATTS: {
    label: 'kW',
    longLabel: 'kilowatts',
    value: SimpleUnits.KILOWATTS,
    mathValue: 'kW',
    measure: Measurements.POWER,
    toStorageUnit: 1000
  },
  KWH: {
    label: 'kWh',
    value: SimpleUnits.KWH,
    mathValue: 'kWh',
    measure: Measurements.THERMAL,
    toStorageUnit: 1000 * 3600 / 1055.05585262 // BTU (IT)

  },
  LBS_PER_MSF: {
    label: 'lbs / MSF',
    value: SimpleUnits.LBS_PER_MSF,
    mathValue: 'lbs / MSF'
  },
  LINEAR_FEET: {
    label: 'linear ft',
    value: SimpleUnits.LINEAR_FEET,
    mathValue: 'linear_ft',
    measure: Measurements.LENGTH,
    toStorageUnit: 1
  },
  LITERS: {
    label: 'L',
    longLabel: 'liters',
    value: SimpleUnits.LITERS,
    mathValue: 'L',
    measure: Measurements.VOLUME,
    toStorageUnit: 0.03531466672149
  },
  MASS_CONCENTRATION: {
    label: 'mass concentration',
    value: SimpleUnits.MASS_CONCENTRATION,
    mathValue: 'mass_concentration',
    measure: Measurements.CONCENTRATION,
    toStorageUnit: 0.00624279606,
    suite: 'water'
  },
  MBF: {
    label: 'thousand board feet',
    mathValue: 'MBF',
    measure: Measurements.VOLUME,
    toStorageUnit: 1000 / 12,
    value: SimpleUnits.MBF
  },
  MCF: {
    label: 'MCF',
    value: SimpleUnits.MCF,
    mathValue: 'MCF',
    measure: Measurements.THERMAL,
    toStorageUnit: 1020000
  },
  MEGAHERTZ: {
    label: 'MHz',
    value: SimpleUnits.MEGAHERTZ,
    mathValue: 'MHz',
    measure: Measurements.FREQUENCY,
    toStorageUnit: 1000000
  },
  MEGAJOULE: {
    label: 'MJ',
    value: SimpleUnits.MEGAJOULE,
    mathValue: 'MJ',
    measure: Measurements.THERMAL,
    toStorageUnit: 1000000 / 1055.05585262 // BTU (IT)

  },
  MEGAWATT_HOURS: {
    label: 'MWh',
    value: SimpleUnits.MEGAWATT_HOURS,
    mathValue: 'MWh',
    measure: Measurements.THERMAL,
    // 3600 MJ == 1 MWh
    toStorageUnit: 1000000 / 1055.05585262 * 3600 // BTU (IT)

  },
  METERS: {
    label: 'm',
    longLabel: 'meters',
    value: SimpleUnits.METERS,
    mathValue: 'm',
    measure: Measurements.LENGTH,
    toStorageUnit: 3.28083989501
  },
  METERS_SQUARED: {
    label: 'm²',
    value: SimpleUnits.METERS_SQUARED,
    mathValue: 'm^2',
    measure: Measurements.AREA,
    toStorageUnit: 10.76391076391,
    exponentBase: SimpleUnits.METERS,
    raisedTo: 2
  },
  METRIC_TONS: {
    label: 'metric tons',
    singularLabel: 'metric ton',
    value: SimpleUnits.METRIC_TONS,
    mathValue: 'metric_tons',
    measure: Measurements.MASS,
    toStorageUnit: 1 * 1000 / 0.45359237
  },
  MG: {
    label: 'mg',
    value: SimpleUnits.MG,
    mathValue: 'mg',
    measure: Measurements.MASS,
    toStorageUnit: 1 / 453592.37
  },
  MGAL: {
    label: 'Mgal',
    longLabel: 'million gallons',
    value: SimpleUnits.MGAL,
    mathValue: 'Mgal',
    measure: Measurements.VOLUME,
    // eslint-disable-next-line @typescript-eslint/no-loss-of-precision
    toStorageUnit: 133680.555555555547
  },
  MICROMHOS: {
    label: 'umhos',
    value: SimpleUnits.MICROMHOS,
    mathValue: 'umho',
    measure: Measurements.ELECTRIC_CONDUCTANCE,
    toStorageUnit: 1,
    suite: 'water'
  },
  MICROSIEMENS: {
    label: 'uS',
    value: SimpleUnits.MICROSIEMENS,
    mathValue: 'uS',
    measure: Measurements.ELECTRIC_CONDUCTANCE,
    toStorageUnit: 1,
    suite: 'water'
  },
  MILES: {
    label: 'miles',
    singularLabel: 'mile',
    value: SimpleUnits.MILES,
    mathValue: 'mi',
    measure: Measurements.LENGTH,
    toStorageUnit: 5280
  },
  MILLIAMPS: {
    label: 'mA',
    longLabel: 'milliamps',
    value: SimpleUnits.MILLIAMPS,
    mathValue: 'milliamp'
  },
  MILLIBAR: {
    label: 'millibar',
    value: SimpleUnits.MILLIBAR,
    mathValue: 'millibar'
  },
  MILLIMHOS: {
    label: 'mmhos',
    value: SimpleUnits.MILLIMHOS,
    mathValue: 'mmho',
    measure: Measurements.ELECTRIC_CONDUCTANCE,
    toStorageUnit: 1000
  },
  MILLION_FIBERS_PER_LITER: {
    label: 'MFL',
    value: SimpleUnits.MILLION_FIBERS_PER_LITER,
    mathValue: 'MFL',
    measure: Measurements.CONCENTRATION,
    toStorageUnit: 0.0000624279605761446,
    suite: 'water'
  },
  MINUTES: {
    label: 'min',
    longLabel: 'minutes',
    value: SimpleUnits.MINUTES,
    mathValue: 'min',
    measure: Measurements.TIME,
    toStorageUnit: 60
  },
  ML: {
    label: 'ml',
    value: SimpleUnits.ML,
    mathValue: 'ml',
    measure: Measurements.VOLUME,
    toStorageUnit: 0.00003531466672149
  },
  ML_PER_LITER_PER_HOUR: {
    label: 'ml/L/h',
    value: SimpleUnits.ML_PER_LITER_PER_HOUR,
    suite: 'water'
  },
  MMHG: {
    label: 'mmHg',
    value: SimpleUnits.MMHG,
    mathValue: 'mmHg',
    measure: Measurements.PRESSURE,
    toStorageUnit: 1
  },
  MMBTU: {
    label: 'MMBTU',
    value: SimpleUnits.MMBTU,
    mathValue: 'MMBTU',
    measure: Measurements.THERMAL,
    toStorageUnit: 1000000
  },
  MMCF: {
    label: 'MMCF',
    mathValue: 'MMCF',
    value: SimpleUnits.MMCF
  },
  MM_CF: {
    label: 'million ft³',
    value: SimpleUnits.MM_CF,
    mathValue: 'million_ft3',
    measure: Measurements.VOLUME,
    toStorageUnit: 1000000
  },
  MOLES: {
    label: 'mol',
    value: SimpleUnits.MOLES,
    mathValue: 'mol'
  },
  MPN: {
    label: 'MPN',
    // new unit for Data 2.0 therefore no conversion in Logs 1.0
    longLabel: 'Most Probable Number',
    value: SimpleUnits.MPN,
    mathValue: 'mpn'
  },
  MPN_PER_100_ML: {
    label: 'mpn/100mL',
    value: SimpleUnits.MPN_PER_100_ML,
    mathValue: 'mpn_per_100ml',
    measure: Measurements.BACTERIA_COUNT,
    toStorageUnit: 1,
    suite: 'water'
  },
  MPN_PER_GRAM: {
    label: 'MPN/g',
    // new unit for Data 2.0 therefore no conversion in Logs 1.0
    value: SimpleUnits.MPN_PER_GRAM,
    mathValue: 'mpn_per_gram'
  },
  M_CF: {
    label: 'thousand ft³',
    value: SimpleUnits.M_CF,
    mathValue: 'thousand_ft3',
    measure: Measurements.VOLUME,
    toStorageUnit: 1000
  },
  MSF: {
    label: 'MSF',
    value: SimpleUnits.MSF,
    mathValue: 'MSF'
  },
  M_SQUARE_FEET: {
    label: 'thousand ft²',
    value: SimpleUnits.M_SQUARE_FEET,
    mathValue: 'thousand_ft2',
    measure: Measurements.AREA,
    toStorageUnit: 1000
  },
  NG: {
    label: 'ng',
    value: SimpleUnits.NG,
    mathValue: 'ng',
    measure: Measurements.MASS,
    toStorageUnit: 1 / 453592370000
  },
  NORMAL_CUBIC_METERS: {
    label: 'Nm³',
    value: SimpleUnits.NORMAL_CUBIC_METERS,
    mathValue: 'Nm3',
    measure: Measurements.VOLUME,
    // eslint-disable-next-line @typescript-eslint/no-loss-of-precision
    toStorageUnit: 35.314666721488588
  },
  NTU: {
    label: 'NTU',
    value: SimpleUnits.NTU,
    mathValue: 'NTU',
    measure: Measurements.TURBIDITY,
    toStorageUnit: 1,
    suite: 'water'
  },
  OVEN_DRY_TONS: {
    label: 'oven dry tons',
    singularLabel: 'oven dry ton',
    value: SimpleUnits.OVEN_DRY_TONS,
    mathValue: 'oven_dry_ton',
    measure: Measurements.MASS,
    toStorageUnit: 2000
  },
  OUNCES: {
    label: 'fl oz',
    longLabel: 'fluid oz',
    value: SimpleUnits.OUNCES,
    mathValue: 'fl_oz',
    measure: Measurements.VOLUME,
    toStorageUnit: 0.00104437934
  },
  OUNCES_DRY: {
    label: 'dry oz',
    value: SimpleUnits.OUNCES_DRY,
    mathValue: 'oz',
    measure: Measurements.MASS,
    toStorageUnit: 1 / 16
  },
  PASCALS: {
    label: 'Pa',
    longLabel: 'pascals',
    value: SimpleUnits.PASCALS,
    mathValue: 'Pa',
    measure: Measurements.PRESSURE,
    toStorageUnit: 0.00750061575845656
  },
  PERCENT: {
    label: '%',
    value: SimpleUnits.PERCENT,
    measure: Measurements.UNITLESS,
    toStorageUnit: 0.01
  },
  PERCENT_GRAMS_PER_LITER: {
    label: '% mass in water',
    value: SimpleUnits.PERCENT_GRAMS_PER_LITER,
    mathValue: 'percent_mass_in_water',
    measure: Measurements.CONCENTRATION,
    toStorageUnit: 0.624279606,
    suite: 'water'
  },
  PERCENT_SURVIVAL: {
    label: '% survival',
    value: SimpleUnits.PERCENT_SURVIVAL,
    mathValue: 'percent_survival',
    measure: Measurements.UNITLESS,
    toStorageUnit: 0.01,
    suite: 'water'
  },
  PERCENT_VOLUME_PER_VOLUME: {
    label: '% v/v',
    value: SimpleUnits.PERCENT_VOLUME_PER_VOLUME,
    mathValue: 'percent_volume',
    measure: Measurements.UNITLESS,
    toStorageUnit: 0.01,
    suite: 'water'
  },
  PERCENT_WEIGHT: {
    label: '% wt',
    value: SimpleUnits.PERCENT_WEIGHT,
    mathValue: 'percent_weight',
    measure: Measurements.UNITLESS,
    toStorageUnit: 0.01
  },
  PERCENT_WEIGHT_PER_VOLUME: {
    label: '% wt/vol',
    value: SimpleUnits.PERCENT_WEIGHT_PER_VOLUME,
    mathValue: 'percent_weight_per_volume',
    measure: Measurements.CONCENTRATION,
    toStorageUnit: 0.624279606,
    suite: 'water'
  },
  PICOCURIES: {
    label: 'pCi',
    longLabel: 'picocuries',
    value: SimpleUnits.PICOCURIES,
    mathValue: 'pCi'
  },
  PICOGRAMS: {
    label: 'pg',
    value: SimpleUnits.PICOGRAMS,
    mathValue: 'pg',
    measure: Measurements.MASS,
    toStorageUnit: 1 / 453592370000000
  },
  PINTS: {
    label: 'pints',
    value: SimpleUnits.PINTS,
    mathValue: 'pints'
  },
  POUNDS: {
    label: 'lbs',
    singularLabel: 'lb',
    value: SimpleUnits.POUNDS,
    mathValue: 'lb',
    measure: Measurements.MASS,
    toStorageUnit: 1
  },
  POUND_MOLES: {
    label: 'lb-mol',
    value: SimpleUnits.POUND_MOLES,
    mathValue: 'lb_mol'
  },
  PPB: {
    label: 'PPB',
    value: SimpleUnits.PPB,
    mathValue: 'PPB',
    measure: Measurements.CONCENTRATION,
    toStorageUnit: 0.000000062427960567
  },
  PPM: {
    label: 'PPM',
    value: SimpleUnits.PPM,
    mathValue: 'PPM',
    measure: Measurements.CONCENTRATION,
    toStorageUnit: 0.000062427960567
  },
  PPM_VOLUME: {
    label: 'PPM volume',
    // new unit for Data 2.0 therefore no conversion in Logs 1.0
    value: SimpleUnits.PPM_VOLUME,
    mathValue: 'PPM_vol'
  },
  PPM_WEIGHT: {
    label: 'PPM weight',
    // new unit for Data 2.0 therefore no conversion in Logs 1.0
    value: SimpleUnits.PPM_WEIGHT,
    mathValue: 'PPM_weight'
  },
  PPT: {
    label: 'PPT',
    value: SimpleUnits.PPT,
    mathValue: 'PPT',
    measure: Measurements.CONCENTRATION,
    toStorageUnit: 0.000000000062427960567
  },
  QUARTS: {
    label: 'quarts',
    value: SimpleUnits.QUARTS,
    mathValue: 'quarts',
    measure: Measurements.VOLUME,
    // eslint-disable-next-line @typescript-eslint/no-loss-of-precision
    toStorageUnit: 0.133680555555555547 / 4
  },
  SCF: {
    label: 'SCF',
    value: SimpleUnits.SCF,
    mathValue: 'SCF',
    measure: Measurements.THERMAL,
    toStorageUnit: 1020
  },
  SECONDS: {
    label: 'sec',
    longLabel: 'seconds',
    value: SimpleUnits.SECONDS,
    mathValue: 's',
    measure: Measurements.TIME,
    toStorageUnit: 1
  },
  SECONDS_SQUARED: {
    label: 'sec²',
    value: SimpleUnits.SECONDS_SQUARED,
    mathValue: 's^2',
    exponentBase: SimpleUnits.SECONDS,
    raisedTo: 2
  },
  SF: {
    label: 'SF',
    value: SimpleUnits.SF,
    mathValue: 'SF'
  },
  SQUARE_FEET: {
    label: 'ft²',
    value: SimpleUnits.SQUARE_FEET,
    mathValue: 'ft^2',
    measure: Measurements.AREA,
    toStorageUnit: 1,
    exponentBase: SimpleUnits.FEET,
    raisedTo: 2
  },
  SU: {
    label: 'SU',
    value: SimpleUnits.SU,
    mathValue: 'SU',
    suite: 'water',
    measure: Measurements.PH,
    toStorageUnit: 1
  },
  TERAHERTZ: {
    label: 'THz',
    value: SimpleUnits.TERAHERTZ,
    mathValue: 'THz',
    measure: Measurements.FREQUENCY,
    toStorageUnit: 1000000000000
  },
  THERMS: {
    label: 'Therms',
    singularLabel: 'Therm',
    value: SimpleUnits.THERMS,
    mathValue: 'thm',
    measure: Measurements.THERMAL,
    toStorageUnit: 100000
  },
  TONS: {
    label: 'tons',
    singularLabel: 'ton',
    value: SimpleUnits.TONS,
    mathValue: 'ton',
    measure: Measurements.MASS,
    toStorageUnit: 2000
  },
  TORR: {
    label: 'Torr',
    value: SimpleUnits.TORR,
    mathValue: 'torr',
    measure: Measurements.PRESSURE,
    toStorageUnit: 1
  },
  TOXIC_UNIT_ACUTE: {
    label: 'TUa',
    value: SimpleUnits.TOXIC_UNIT_ACUTE,
    mathValue: 'TUa',
    suite: 'water',
    measure: Measurements.TOXICITY,
    toStorageUnit: 1
  },
  UG: {
    label: 'ug',
    value: SimpleUnits.UG,
    mathValue: 'ug',
    measure: Measurements.MASS,
    toStorageUnit: 1 / 453592370
  },
  UNITLESS: {
    label: 'unitless',
    value: SimpleUnits.UNITLESS,
    measure: Measurements.UNITLESS,
    toStorageUnit: 1
  },
  VMT: {
    label: 'vehicle miles traveled',
    mathValue: 'VMT',
    measure: Measurements.LENGTH,
    toStorageUnit: 5280,
    value: SimpleUnits.VMT
  },
  VOLTS: {
    label: 'V',
    longLabel: 'volts',
    value: SimpleUnits.VOLTS,
    mathValue: 'volt'
  },
  VOLUME_CONCENTRATION: {
    label: 'volume concentration',
    // new unit for Data 2.0 therefore no conversion in Logs 1.0
    value: SimpleUnits.VOLUME_CONCENTRATION,
    mathValue: 'volume_concentration'
  },
  WATTS: {
    label: 'W',
    longLabel: 'watts',
    value: SimpleUnits.WATTS,
    mathValue: 'W',
    measure: Measurements.POWER,
    toStorageUnit: 1
  },
  WATT_HOURS: {
    label: 'Wh',
    value: SimpleUnits.WATT_HOURS,
    mathValue: 'Wh',
    measure: Measurements.THERMAL,
    toStorageUnit: 3600 / 1055.05585262 // BTU (IT)

  },
  WEIGHT_CONCENTRATION: {
    label: 'weight concentration',
    // new unit for Data 2.0 therefore no conversion in Logs 1.0
    value: SimpleUnits.WEIGHT_CONCENTRATION,
    mathValue: 'weight_concentration'
  },
  YARDS: {
    label: 'yards',
    singularLabel: 'yard',
    value: SimpleUnits.YARDS,
    mathValue: 'yd',
    measure: Measurements.LENGTH,
    toStorageUnit: 3
  },
  YEARS: {
    label: 'years',
    singularLabel: 'year',
    value: SimpleUnits.YEARS,
    mathValue: 'year',
    measure: Measurements.TIME,
    toStorageUnit: 31536000
  }
};
exports.SIMPLE_UNIT_TYPES = SIMPLE_UNIT_TYPES;
var NON_GENERATED_COMPLEX_UNIT_TYPES = {
  BTU_PER_GALLON: {
    label: 'BTU/gal',
    value: "".concat(SimpleUnits.BTU, "/").concat(SimpleUnits.GALLONS),
    mathValue: 'BTU/gal'
  },
  BTU_PER_POUND: {
    label: 'BTU/lb',
    value: "".concat(SimpleUnits.BTU, "/").concat(SimpleUnits.POUNDS),
    mathValue: 'BTU/lb'
  },
  CUBIC_CENTIMETERS_PER_OUNCES: {
    label: 'cm³/dry oz',
    value: "".concat(SimpleUnits.CUBIC_CENTIMETERS, "/").concat(SimpleUnits.OUNCES_DRY),
    mathValue: 'cm^3/oz'
  },
  CUBIC_YARDS_PER_POUND: {
    label: 'yards³/lb',
    value: "".concat(SimpleUnits.CUBIC_YARDS, "/").concat(SimpleUnits.POUNDS),
    mathValue: 'yd^3/lb'
  },
  DOLLARS_PER_GALLON: {
    label: '$/gal',
    value: "".concat(SimpleUnits.DOLLARS, "/").concat(SimpleUnits.GALLONS),
    mathValue: 'USD/gal'
  },
  DOLLARS_PER_JOULE: {
    label: '$/J',
    value: "".concat(SimpleUnits.DOLLARS, "/").concat(SimpleUnits.JOULE),
    mathValue: 'USD/J'
  },
  DOLLARS_PER_KILOJOULE: {
    label: '$/kJ',
    value: "".concat(SimpleUnits.DOLLARS, "/").concat(SimpleUnits.KILOJOULE),
    mathValue: 'USD/kJ'
  },
  DOLLARS_PER_KWH: {
    label: '$/kWh',
    value: "".concat(SimpleUnits.DOLLARS, "/").concat(SimpleUnits.KWH),
    mathValue: 'USD/kWh'
  },
  DOLLARS_PER_MEGAJOULE: {
    label: '$/MJ',
    value: "".concat(SimpleUnits.DOLLARS, "/").concat(SimpleUnits.MEGAJOULE),
    mathValue: 'USD/MJ'
  },
  DOLLARS_PER_THERM: {
    label: '$/thm',
    value: "".concat(SimpleUnits.DOLLARS, "/").concat(SimpleUnits.THERMS),
    mathValue: 'USD/thm'
  },
  DOLLARS_PER_WATT_HOUR: {
    label: '$/Wh',
    value: "".concat(SimpleUnits.DOLLARS, "/").concat(SimpleUnits.WATT_HOURS),
    mathValue: 'USD/Wh'
  },
  FEET_PER_SECOND_SQUARED: {
    label: 'ft/sec²',
    value: "".concat(SimpleUnits.FEET, "/").concat(SimpleUnits.SECONDS_SQUARED),
    mathValue: 'ft/s^2'
  },
  FEET_EXP_ZERO_FIVE_PER_SECOND: {
    label: '√ft/sec',
    value: "".concat(SimpleUnits.FEET_EXP_ZERO_FIVE, "/").concat(SimpleUnits.SECONDS),
    mathValue: 'ft^0.5/s'
  },
  GALLONS_PER_POUND: {
    label: 'gallons/lb',
    value: "".concat(SimpleUnits.GALLONS, "/").concat(SimpleUnits.POUNDS),
    mathValue: 'gal/lb'
  },
  GIGAJOULE_PER_METRIC_TON: {
    label: 'GJ/metric ton',
    value: "".concat(SimpleUnits.GIGAJOULE, "/").concat(SimpleUnits.METRIC_TONS),
    mathValue: 'GJ/tonne'
  },
  GIGAJOULE_PER_NORMAL_CUBIC_METER: {
    label: 'GJ/Nm³',
    value: "".concat(SimpleUnits.GIGAJOULE, "/").concat(SimpleUnits.NORMAL_CUBIC_METERS),
    mathValue: 'GJ/m^3'
  },
  GRAMS_PER_GRAM_MOLE: {
    label: 'g/g-mol',
    value: "".concat(SimpleUnits.GRAMS, "/").concat(SimpleUnits.GRAM_MOLES),
    mathValue: 'g/g_mol'
  },
  GRAMS_PER_HORSEPOWER_HOUR: {
    label: 'g/(hp·hr)',
    value: "".concat(SimpleUnits.GRAMS, "/").concat(SimpleUnits.HORSEPOWER_HOURS),
    mathValue: 'g/(hp*hr)'
  },
  GRAMS_PER_KWH: {
    label: 'g/kWh',
    value: "".concat(SimpleUnits.GRAMS, "/").concat(SimpleUnits.KWH),
    mathValue: 'g/kWh'
  },
  GRAMS_PER_MOLE: {
    label: 'g/mol',
    value: "".concat(SimpleUnits.GRAMS, "/").concat(SimpleUnits.MOLES),
    mathValue: 'g/mol'
  },
  KG_PER_MMBTU: {
    label: 'kg/MMBTU',
    value: "".concat(SimpleUnits.KILOGRAMS, "/").concat(SimpleUnits.MMBTU),
    mathValue: 'kg/MMBTU'
  },
  KG_PER_KG: {
    label: 'kg/kg',
    value: "".concat(SimpleUnits.KILOGRAMS, "/").concat(SimpleUnits.KILOGRAMS),
    mathValue: 'kg/kg'
  },
  MEGAJOULE_PER_NORMAL_CUBIC_METER: {
    label: 'MJ/Nm³',
    value: "".concat(SimpleUnits.MEGAJOULE, "/").concat(SimpleUnits.NORMAL_CUBIC_METERS),
    mathValue: 'MJ/m^3'
  },
  ML_PER_LITER: {
    label: 'ml/L',
    value: "".concat(SimpleUnits.ML, "/").concat(SimpleUnits.LITERS),
    mathValue: 'ml/l',
    measure: Measurements.UNITLESS,
    suite: 'water',
    toStorageUnit: 1
  },
  MMBTU_PER_GALLON: {
    label: 'MMBTU/gal',
    value: "".concat(SimpleUnits.MMBTU, "/").concat(SimpleUnits.GALLONS),
    mathValue: 'MMBTU/gal'
  },
  MMBTU_PER_HOUR: {
    label: 'MMBTU/hr',
    value: "".concat(SimpleUnits.MMBTU, "/").concat(SimpleUnits.HOURS),
    mathValue: 'MMBTU/hr'
  },
  MMBTU_PER_METRIC_TON: {
    label: 'MMBTU/metric ton',
    value: "".concat(SimpleUnits.MMBTU, "/").concat(SimpleUnits.METRIC_TONS),
    mathValue: 'MMBTU/tonne'
  },
  MMBTU_PER_SCF: {
    label: 'MMBTU/SCF',
    value: "".concat(SimpleUnits.MMBTU, "/").concat(SimpleUnits.SCF),
    mathValue: 'MMBTU/SCF'
  },
  MMBTU_PER_TON: {
    label: 'MMBTU/ton',
    value: "".concat(SimpleUnits.MMBTU, "/").concat(SimpleUnits.TONS),
    mathValue: 'MMBTU / ton'
  },
  POUNDS_PER_HORSEPOWER_HOUR: {
    label: 'lbs/(hp·hr)',
    value: "".concat(SimpleUnits.POUNDS, "/").concat(SimpleUnits.HORSEPOWER_HOURS),
    mathValue: 'lb/(hp*hr)'
  },
  POUNDS_PER_MEGAWATT_HOUR: {
    label: 'lbs/MWh',
    value: "".concat(SimpleUnits.POUNDS, "/").concat(SimpleUnits.MEGAWATT_HOURS),
    mathValue: 'lb/MWh'
  },
  POUNDS_PER_MILE: {
    label: 'lbs/mile',
    value: "".concat(SimpleUnits.POUNDS, "/").concat(SimpleUnits.MILES),
    mathValue: 'lbs/mi'
  },
  POUNDS_PER_VEHICLE_MILE_TRAVELED: {
    label: 'lbs/vehicle mile traveled',
    value: "".concat(SimpleUnits.POUNDS, "/").concat(SimpleUnits.VMT),
    mathValue: 'lbs/VMT'
  },
  POUNDS_PER_MMBTU: {
    label: 'lbs/MMBTU',
    value: "".concat(SimpleUnits.POUNDS, "/").concat(SimpleUnits.MMBTU),
    mathValue: 'lbs/MMBTU'
  },
  POUNDS_PER_POUND_MOLE: {
    label: 'lbs/lb-mol',
    value: "".concat(SimpleUnits.POUNDS, "/").concat(SimpleUnits.POUND_MOLES),
    mathValue: 'lbs/lb_mol'
  },
  POUNDS_PER_SQUARE_FOOT: {
    label: 'lbs/ft²',
    value: "".concat(SimpleUnits.POUNDS, "/").concat(SimpleUnits.SQUARE_FEET),
    mathValue: 'lbs/ft^2'
  },
  POUNDS_PER_SQUARE_INCH: {
    label: 'lbs/in²',
    // We can't use `${SimpleUnits.POUNDS}/${SimpleUnits.INCHES_SQUARED}` because that's already the value for PSI below
    // changing PSI would require a migration for logs 1.0 data, which is soon to be sunset. We don't use this `value` for
    // anything in EDP anyways, so having it as a not-quite-right value is okay
    value: "lbs/inches-squared",
    mathValue: 'lbs/in^2'
  },
  POUNDS_PER_TON: {
    label: 'lbs/ton',
    value: "".concat(SimpleUnits.POUNDS, "/").concat(SimpleUnits.TONS),
    mathValue: 'lbs/ton'
  },
  PSI: {
    label: 'PSI',
    value: "".concat(SimpleUnits.POUNDS, "/").concat(SimpleUnits.INCHES_SQUARE),
    measure: Measurements.PRESSURE,
    toStorageUnit: 51.7149252026091,
    mathValue: 'psi'
  },
  SCFM: {
    label: 'SCFM',
    value: "".concat(SimpleUnits.SCF, "/").concat(SimpleUnits.MINUTES),
    measure: Measurements.FLOW_RATE,
    mathValue: 'SCFM'
  }
};
exports.NON_GENERATED_COMPLEX_UNIT_TYPES = NON_GENERATED_COMPLEX_UNIT_TYPES;

function getRelatedSimpleUnitTypes(simpleUnitValue) {
  var simpleUnitTypeList = Object.values(SIMPLE_UNIT_TYPES);
  var unitType = simpleUnitTypeList.find(function (ut) {
    return ut.value === simpleUnitValue;
  });

  if (!unitType) {
    throw new Error("Simple unit configuration is missing for \"".concat(simpleUnitValue, "\""));
  }

  var measurementGroup = unitType.measure;

  if (measurementGroup) {
    return simpleUnitTypeList.filter(function (ut) {
      return ut.measure === measurementGroup;
    });
  } // If a unit doesn't belong to any measurement group
  // return a list of itself


  return [unitType];
}

function generateComplexUnitTypesForMeasurementGroups() {
  var complexUnitTypesList = [];
  Object.values(Measurements).forEach(function (measure) {
    var storageUnitValue = MEASUREMENT_STORAGE_UNITS[measure];

    if (!isComplexUnit(storageUnitValue)) {
      return;
    }

    var _splitComplexUnitInto = splitComplexUnitIntoSimpleUnits(storageUnitValue),
        _splitComplexUnitInto2 = _slicedToArray(_splitComplexUnitInto, 2),
        numeratorValue = _splitComplexUnitInto2[0],
        denominatorValue = _splitComplexUnitInto2[1];

    var numeratorRelatedUnitTypes = getRelatedSimpleUnitTypes(numeratorValue);
    var denominatorRelatedUnitTypes = getRelatedSimpleUnitTypes(denominatorValue);
    numeratorRelatedUnitTypes.forEach(function (numeratorUnitType) {
      denominatorRelatedUnitTypes.forEach(function (denominatorUnitType) {
        var denominatorLabel = denominatorUnitType.singularLabel || denominatorUnitType.label;
        var mathValue = numeratorUnitType.mathValue && denominatorUnitType.mathValue ? "".concat(numeratorUnitType.mathValue, " / ").concat(denominatorUnitType.mathValue) : '';
        complexUnitTypesList.push({
          label: "".concat(numeratorUnitType.label, "/").concat(denominatorLabel),
          value: "".concat(numeratorUnitType.value, "/").concat(denominatorUnitType.value),
          mathValue: mathValue,
          measure: measure
        });
      });
    });
  });
  return complexUnitTypesList;
}

var COMPLEX_UNIT_TYPES_LIST = [].concat(_toConsumableArray(Object.values(NON_GENERATED_COMPLEX_UNIT_TYPES)), _toConsumableArray(generateComplexUnitTypesForMeasurementGroups()));
exports.COMPLEX_UNIT_TYPES_LIST = COMPLEX_UNIT_TYPES_LIST;
var UNIT_TYPES_LIST = [].concat(_toConsumableArray(Object.values(SIMPLE_UNIT_TYPES)), _toConsumableArray(COMPLEX_UNIT_TYPES_LIST));
exports.UNIT_TYPES_LIST = UNIT_TYPES_LIST;

function isUnitString(s) {
  if (!s || typeof s !== 'string') return false;
  return !!UNIT_TYPES_LIST.find(function (value) {
    return value.value === s;
  });
}

function getUnitForStorage(unitValue) {
  var unitType = UNIT_TYPES_LIST.find(function (u) {
    return u.value === unitValue;
  });

  if (unitType !== null && unitType !== void 0 && unitType.measure) {
    var measurementStorageUnit = MEASUREMENT_STORAGE_UNITS[unitType.measure];
    if (measurementStorageUnit) return measurementStorageUnit;
  }

  if (isComplexUnit(unitValue)) {
    var _splitComplexUnitInto3 = splitComplexUnitIntoSimpleUnits(unitValue),
        _splitComplexUnitInto4 = _slicedToArray(_splitComplexUnitInto3, 2),
        numeratorValue = _splitComplexUnitInto4[0],
        denominatorValue = _splitComplexUnitInto4[1];

    var numeratorStorageValue = getUnitForStorage(numeratorValue);
    var denominatorStorageValue = getUnitForStorage(denominatorValue);

    if (isComplexUnit(numeratorStorageValue) || isComplexUnit(denominatorStorageValue)) {
      throw new Error("Couldn't find a storage unit for ".concat(unitValue));
    }

    return "".concat(numeratorStorageValue, "/").concat(denominatorStorageValue);
  } // If no storage unit was defined for a measurement group
  // or unit doesn't belong to any group – return that unit value


  if (unitType) return unitType.value; // A unit is of unknown type, store it as is

  return unitValue;
}

function getRelatedUnits(unitValue) {
  var unitType = UNIT_TYPES_LIST.find(function (v) {
    return v.value === unitValue;
  }); // Returns units of the same measurement which can be converted one to another

  if (unitType && unitType.measure) {
    return UNIT_TYPES_LIST.filter(function (ut) {
      return ut.measure === unitType.measure;
    });
  }

  if (unitType && !unitType.measure) {
    return [unitType];
  } // If we don't have given complex units in the list of unit types,
  // it means that it came from the custom calculated value.
  // Create corresponding unit type on the fly and return only it
  // because it related only to itself.


  if (!unitType && isComplexUnit(unitValue)) {
    var factors = splitComplexUnitIntoSimpleUnits(unitValue);
    var numerator = UNIT_TYPES_LIST.find(function (v) {
      return v.value === factors[0];
    });
    var denominator = UNIT_TYPES_LIST.find(function (v) {
      return v.value === factors[1];
    });
    if (!numerator) throw new Error("Complex Unit encountered with invalid numerator ".concat(factors[0]));
    if (!denominator) throw new Error("Complex Unit encountered with invalid denominator ".concat(factors[1]));
    return [{
      label: "".concat(numerator.label, " / ").concat(denominator.label),
      value: unitValue
    }];
  }

  return [];
}

function unitsAreRelated(unitValue1, unitValue2) {
  if (unitValue1 === unitValue2) {
    return true;
  }

  var relatedUnitValues1 = getRelatedUnits(unitValue1).map(function (u) {
    return u.value;
  });

  if (relatedUnitValues1.includes(unitValue2)) {
    return true;
  }

  if (!isComplexUnit(unitValue1) || !isComplexUnit(unitValue2)) {
    return false;
  }

  var _splitComplexUnitInto5 = splitComplexUnitIntoSimpleUnits(unitValue1),
      _splitComplexUnitInto6 = _slicedToArray(_splitComplexUnitInto5, 2),
      numeratorValue1 = _splitComplexUnitInto6[0],
      denominatorValue1 = _splitComplexUnitInto6[1];

  var _splitComplexUnitInto7 = splitComplexUnitIntoSimpleUnits(unitValue2),
      _splitComplexUnitInto8 = _slicedToArray(_splitComplexUnitInto7, 2),
      numeratorValue2 = _splitComplexUnitInto8[0],
      denominatorValue2 = _splitComplexUnitInto8[1];

  return unitsAreRelated(numeratorValue1, numeratorValue2) && unitsAreRelated(denominatorValue1, denominatorValue2);
}

function getComplexMeasurementGroup(unitValue) {
  var storageUnitValue = getUnitForStorage(unitValue);
  var storageUnitType = UNIT_TYPES_LIST.find(function (u) {
    return u.value === storageUnitValue;
  });
  return storageUnitType === null || storageUnitType === void 0 ? void 0 : storageUnitType.measure;
}

function getSimpleMultiplier(fromUnit, toUnit) {
  var fromUnitType = UNIT_TYPES_LIST.find(function (u) {
    return u.value === fromUnit;
  });
  var toUnitType = UNIT_TYPES_LIST.find(function (u) {
    return u.value === toUnit;
  });
  var fromMeasurementGroup = fromUnitType === null || fromUnitType === void 0 ? void 0 : fromUnitType.measure;
  var toMeasurementGroup = toUnitType === null || toUnitType === void 0 ? void 0 : toUnitType.measure; // Simple and complex units can belong to the same measurement group, e.g. mg/L and PPM.
  // But not all complex units are in our complex units list,
  // e.g. user may create a calculation that results in such unit.
  // In this case we need to get measurement group of its storage unit.

  if (!fromUnitType && isComplexUnit(fromUnit)) {
    fromMeasurementGroup = getComplexMeasurementGroup(fromUnit);
  }

  if (!toUnitType && isComplexUnit(toUnit)) {
    toMeasurementGroup = getComplexMeasurementGroup(toUnit);
  }

  if (!fromMeasurementGroup || !toMeasurementGroup || fromMeasurementGroup !== toMeasurementGroup) {
    return null;
  }

  var currentToStorageUnit = fromUnitType === null || fromUnitType === void 0 ? void 0 : fromUnitType.toStorageUnit;
  var targetToStorageUnit = toUnitType === null || toUnitType === void 0 ? void 0 : toUnitType.toStorageUnit; // Simple and complex units can belong to the same measurement group, e.g. mg/L and PPM.
  // In this case "toStorageUnit" will only present on simple unit type or
  // if storage unit is a simple unit.
  // If no "toStorageUnit" we need to get it through "getComplexMultiplier".

  var storageUnit = MEASUREMENT_STORAGE_UNITS[fromMeasurementGroup];

  if (!currentToStorageUnit) {
    if (!isComplexUnit(fromUnit) || !isComplexUnit(storageUnit)) return null; // eslint-disable-next-line @typescript-eslint/no-use-before-define

    currentToStorageUnit = getComplexMultiplier(fromUnit, storageUnit);
  }

  if (!targetToStorageUnit) {
    if (!isComplexUnit(toUnit) || !isComplexUnit(storageUnit)) return null; // eslint-disable-next-line @typescript-eslint/no-use-before-define

    targetToStorageUnit = getComplexMultiplier(toUnit, storageUnit);
  }

  if (!currentToStorageUnit || !targetToStorageUnit) {
    return null;
  }

  var storageToTargetUnit = 1 / targetToStorageUnit;
  return currentToStorageUnit * storageToTargetUnit;
}

function getComplexMultiplier(fromUnit, toUnit) {
  var numeratorMultiplier = 1;
  var denominatorMultiplier = 1;
  var splittedFromUnit = splitComplexUnitIntoSimpleUnits(fromUnit);
  var fromNumerator = splittedFromUnit[0];
  var fromDenominator = splittedFromUnit[1];
  var splittedToUnit = splitComplexUnitIntoSimpleUnits(toUnit);
  var toNumerator = splittedToUnit[0];
  var toDenominator = splittedToUnit[1];

  if (fromNumerator !== toNumerator) {
    numeratorMultiplier = getSimpleMultiplier(fromNumerator, toNumerator);

    if (numeratorMultiplier === null) {
      return null;
    }
  }

  if (fromDenominator !== toDenominator) {
    denominatorMultiplier = getSimpleMultiplier(fromDenominator, toDenominator);

    if (denominatorMultiplier === null) {
      return null;
    }
  }

  return numeratorMultiplier / denominatorMultiplier;
}

function getUnitConversionMultiplier(fromUnit, toUnit) {
  if (isComplexUnit(fromUnit) && isComplexUnit(toUnit)) {
    return getComplexMultiplier(fromUnit, toUnit);
  }

  return getSimpleMultiplier(fromUnit, toUnit);
}

function findByValue(unit) {
  return UNIT_TYPES_LIST.find(function (value) {
    return value.value === unit;
  });
}

function getUnitLabel(unit) {
  var unitType = findByValue(unit);
  if (!unitType) return unit;
  return unitType.label;
}

function convertWithFormula(value, fromUnitType, toUnitType) {
  var inStorageUnits = fromUnitType.toStorageUnitFunc(value);
  return toUnitType.fromStorageUnitFunc(inStorageUnits);
}

function requiresFormulaConversion(unitType) {
  return 'toStorageUnitFunc' in unitType && 'fromStorageUnitFunc' in unitType;
}

function unitsAreEqual(unitA, unitB) {
  if (unitA === unitB) {
    return true;
  }

  if ((!unitA || unitA === SimpleUnits.UNITLESS) && (!unitB || unitB === SimpleUnits.UNITLESS)) {
    return true;
  }

  return false;
}

function convertUnits(value, fromUnit, toUnit) {
  if (value == null) {
    return null;
  }

  if (unitsAreEqual(fromUnit, toUnit)) {
    return value;
  }

  var fromUnitType = findByValue(fromUnit);
  var toUnitType = findByValue(toUnit);

  if (fromUnitType && toUnitType && requiresFormulaConversion(fromUnitType) && requiresFormulaConversion(toUnitType)) {
    return convertWithFormula(value, fromUnitType, toUnitType);
  }

  var multiplier = getUnitConversionMultiplier(fromUnit, toUnit); // If multiplier is null there is no conversion defined for given units,
  // returning null here to signal the caller that conversion couldn't be performed.

  if (multiplier === null) return null;
  return value * multiplier;
}

/**
 * Convert a value from a given unit
 *
 * @param value
 * @param fromUnit - the unitType value OR label
 * @param toUnits - a hash map of desired output units for each given Measurement type
 */
function convertToPreferredUnitsForAnalytics(value, fromUnit, toUnits) {
  var unchanged = {
    value: value,
    unit: fromUnit,
    unitLabel: getUnitLabel(fromUnit)
  };
  var fromUnitType = findByValue(fromUnit);
  if (!fromUnitType || value === null || value === undefined) return unchanged;
  var measure = fromUnitType.measure;
  var toUnit = toUnits[measure];
  if (!toUnit || unitsAreEqual(fromUnit, toUnit)) return unchanged;
  var converted = convertUnits(value, fromUnit, toUnit);
  if (converted === null) return unchanged;
  return {
    value: converted,
    unit: toUnit,
    unitLabel: getUnitLabel(toUnit)
  };
}
/**
 * This method is used by Snowflake JS function in analytics, which is why it takes N parameters instead of an object
 *
 */
// eslint-disable-next-line @typescript-eslint/no-unused-vars


function convertUnitForAnalytics(value, fromUnit) {
  var _toUnits;

  var AREA_UNIT = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  var BACTERIA_COUNT_UNIT = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
  var BOOLEAN_UNIT = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '';
  var CONCENTRATION_UNIT = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : '';
  var CURRENCY_UNIT = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : '';
  var ELECTRIC_CONDUCTANCE_UNIT = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : '';
  var FLOW_RATE_UNIT = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : '';
  var FREQUENCY = arguments.length > 9 && arguments[9] !== undefined ? arguments[9] : '';
  var LENGTH_UNIT = arguments.length > 10 && arguments[10] !== undefined ? arguments[10] : '';
  var MASS_UNIT = arguments.length > 11 && arguments[11] !== undefined ? arguments[11] : '';
  var MASS_LOAD_UNIT = arguments.length > 12 && arguments[12] !== undefined ? arguments[12] : '';
  var PH_UNIT = arguments.length > 13 && arguments[13] !== undefined ? arguments[13] : '';
  var POWER_UNIT = arguments.length > 14 && arguments[14] !== undefined ? arguments[14] : '';
  var PRESSURE_UNIT = arguments.length > 15 && arguments[15] !== undefined ? arguments[15] : '';
  var RADON_LEVEL_UNIT = arguments.length > 16 && arguments[16] !== undefined ? arguments[16] : '';
  var SOIL_ELECTRICAL_CONDUCTIVITY_UNIT = arguments.length > 17 && arguments[17] !== undefined ? arguments[17] : '';
  var TEMPERATURE_UNIT = arguments.length > 18 && arguments[18] !== undefined ? arguments[18] : '';
  var THERMAL_UNIT = arguments.length > 19 && arguments[19] !== undefined ? arguments[19] : '';
  var TIME_UNIT = arguments.length > 20 && arguments[20] !== undefined ? arguments[20] : '';
  var TOXICITY_UNIT = arguments.length > 21 && arguments[21] !== undefined ? arguments[21] : '';
  var TURBIDITY_UNIT = arguments.length > 22 && arguments[22] !== undefined ? arguments[22] : '';
  var UNITLESS_UNIT = arguments.length > 23 && arguments[23] !== undefined ? arguments[23] : '';
  var VELOCITY = arguments.length > 24 && arguments[24] !== undefined ? arguments[24] : '';
  var VOLUME_UNIT = arguments.length > 25 && arguments[25] !== undefined ? arguments[25] : '';
  var toUnits = (_toUnits = {}, _defineProperty(_toUnits, Measurements.AREA, AREA_UNIT), _defineProperty(_toUnits, Measurements.BACTERIA_COUNT, BACTERIA_COUNT_UNIT), _defineProperty(_toUnits, Measurements.BOOLEAN, BOOLEAN_UNIT), _defineProperty(_toUnits, Measurements.CONCENTRATION, CONCENTRATION_UNIT), _defineProperty(_toUnits, Measurements.CURRENCY, CURRENCY_UNIT), _defineProperty(_toUnits, Measurements.ELECTRIC_CONDUCTANCE, ELECTRIC_CONDUCTANCE_UNIT), _defineProperty(_toUnits, Measurements.FLOW_RATE, FLOW_RATE_UNIT), _defineProperty(_toUnits, Measurements.FREQUENCY, FREQUENCY), _defineProperty(_toUnits, Measurements.LENGTH, LENGTH_UNIT), _defineProperty(_toUnits, Measurements.MASS, MASS_UNIT), _defineProperty(_toUnits, Measurements.MASS_LOAD, MASS_LOAD_UNIT), _defineProperty(_toUnits, Measurements.PH, PH_UNIT), _defineProperty(_toUnits, Measurements.POWER, POWER_UNIT), _defineProperty(_toUnits, Measurements.PRESSURE, PRESSURE_UNIT), _defineProperty(_toUnits, Measurements.RADON_LEVEL, RADON_LEVEL_UNIT), _defineProperty(_toUnits, Measurements.SOIL_ELECTRICAL_CONDUCTIVITY, SOIL_ELECTRICAL_CONDUCTIVITY_UNIT), _defineProperty(_toUnits, Measurements.TEMPERATURE, TEMPERATURE_UNIT), _defineProperty(_toUnits, Measurements.TIME, TIME_UNIT), _defineProperty(_toUnits, Measurements.TOXICITY, TOXICITY_UNIT), _defineProperty(_toUnits, Measurements.TURBIDITY, TURBIDITY_UNIT), _defineProperty(_toUnits, Measurements.THERMAL, THERMAL_UNIT), _defineProperty(_toUnits, Measurements.UNITLESS, UNITLESS_UNIT), _defineProperty(_toUnits, Measurements.VELOCITY, VELOCITY), _defineProperty(_toUnits, Measurements.VOLUME, VOLUME_UNIT), _toUnits);
  return convertToPreferredUnitsForAnalytics(value, fromUnit, toUnits);
}